import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import SchemaOrganization from "./SchemaOrganization";

/**
 * avoid using this component directly
 * use `SchemaOrganization.SameAs` instead
 */
var SchemaSameAsOrganization = function SchemaSameAsOrganization(props) {
  return /*#__PURE__*/React.createElement(SchemaOrganization, _extends({
    sameAs: true
  }, props));
};

SchemaSameAsOrganization.displayName = "SchemaSameAsOrganization";
export default SchemaSameAsOrganization;